<template>
  <div>
    <Layout />
    <CookieConsent />
  </div>
</template>

<script>
import Layout from "@/components/Layout/Layout.vue";
import CookieConsent from "../components/Shared/CookieConsent/CookieConsent.vue";

export default {
  name: "Home",
  components: {
    Layout,
    CookieConsent
  },
};
</script>
